<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 xl:gap-16 px-4 lg:px-0">
        <template v-if="topics.length > 0">
            <template v-for="topic in topics">
                <TopicCard :key="topic.id" :topic="topic" />
            </template>
        </template>
        <template v-else>
            <div
                v-for="n in 6"
                :key="n"
                class="rounded-lg bg-white hover:bg-gray-100 shadow-md hover:shadow-lg border-transparent overflow-hidden h-full"
            >
                <div class="relative h-56 sm:h-60 bg-gray-300 animate-pulse"></div>
                <div class="px-6 pt-4 pb-6">
                    <div class="mt-2 h-6 mr-10 bg-gray-200 rounded animate-pulse"></div>
                    <div class="mt-4 h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import TopicCard from './TopicCard.vue';
export default {
    components: { TopicCard },
    data() {
        return {
            topics: []
        };
    },

    mounted() {
        this.fetchTopics();
    },

    methods: {
        fetchTopics() {
            fetch(
                `${process.env.MIX_RUMIE_BASE_URL}/api/v3/learn/projects/1/trending/bytes?limit=6&offset=20&engagement=true&range=&language=English`
            )
                .then(response => response.json())
                .then(response => {
                    this.topics = response;
                });
        }
    }
};
</script>
